var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('d-button',{attrs:{"size":"small"}},[_vm._v("我是一个按钮")]),_c('d-button',[_vm._v("我是一个按钮")]),_c('d-button',{attrs:{"size":"large"}},[_vm._v("我是一个按钮")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }